import type { ChangeEvent, FormEvent } from 'react'
import SearchField from '@molecules/SearchField'
import { scopedTranslation } from '@utils/I18n'

import useSupporterFilteringStore from '../filter-supporters/stores/useSupporterFilteringStore'

const tGroupShow = scopedTranslation('group_show')

export function SupporterSearchField() {
  const name = useSupporterFilteringStore((state) => state.supporterName)
  const setName = useSupporterFilteringStore((state) => state.updateName)

  return (
    <form
      className='tw:w-full'
      onSubmit={(event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
      }}
    >
      <SearchField
        fieldName="supporter_name"
        defaultValue={name}
        displayName={tGroupShow('search_supporters_label')}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          setName(event.target.value)
        }}
        dataCompId="group-detail-page_search-field"
      />
    </form>
  )
}
